import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';

function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '} {new Date().getFullYear()} {' '}
        <Link color="inherit" href="https://www.jababeka.com/" target="_blank">
          Kawasan Industri Jababeka
        </Link>
        {'.'}
      </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(20)
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    divider: {
        marginBottom: theme.spacing(0)
    },
}));

export default function AlreadyConfirmPayment() {
    const classes = useStyles();

    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar alt="Job Fair Logo" src="/logo512.png" variant="square" className={classes.large} />
                <Typography component="h1" variant="h5">
                    KAWASAN INDUSTRI JABABEKA
                </Typography>
                <Typography variant="subtitle1">
                    PROUDLY PRESENT
                </Typography>
                <Typography component="h1" variant="h6">
                    VIRTUAL JOB FAIR 2021
                </Typography>
                <Divider variant="middle" className={classes.divider} />
            </div>
            <Grid container spacing={1} className={classes.form}>
                <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                        Kamu sudah pernah melakukan konfirmasi pembayaran. Silahkan periksa email kamu secara berkala ya.
                    </Typography>
                </Grid>
            </Grid>
            <Box mt={25} mb={5}>
                <Copyright />
            </Box>
        </Container>
    );
}